import { NOTES_DEMO_CONTENT } from './notesDemoContent'
import { noteAt, withContent } from './notesRailDemoNoteUtils'

/** @type {import('../lib/types.js').NotesRailNoteWire} */
export const notesRailDemoMeetingDemo = withContent({
  id: 'n-meeting-demo',
  kind: 'meeting',
  authorName: 'Alex Morgan',
  participants: [
    { name: 'Alex Rivera', email: 'alex.rivera@company.com' },
    { name: 'Jordan Lee', email: 'jordan.lee@company.com' },
    { name: 'Sam Patel', email: 'sam.patel@company.com' },
    { name: 'Taylor Chen', email: 'taylor.chen@company.com' },
    {
      name: 'Riley Chen',
      email: 'riley.chen@clientcorp.com',
      isOrgMember: false,
      hasPlatformAccount: false,
    },
    {
      name: 'Guest Vendor',
      email: 'vendor@gmail.com',
      isOrgMember: false,
      hasPlatformAccount: false,
    },
  ],
  title: 'Product sync — action items',
  content: NOTES_DEMO_CONTENT.meetingProductSync,
  at: noteAt(11, 13, 2),
  meetingStartedAt: noteAt(11, 13, 2),
})
